function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.41565 2C7.41565 1.34417 7.92747 0.864865 8.5833 0.864865H13.3833C14.039 0.864865 14.5508 1.34417 14.5508 2V3.24324H15.4156V2C15.4156 0.867399 14.5159 0 13.3833 0H8.5833C7.4507 0 6.55078 0.867399 6.55078 2V3.24324H7.41565V2Z",
  fill: "#84CDBD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.86867 22.0004H16.0957C17.0817 22.0004 17.8469 21.133 17.8469 20.0545V6.70312H4.11719V20.0545C4.11719 21.133 4.88239 22.0004 5.86867 22.0004ZM13.7388 8.76795C13.7388 8.52914 13.9324 8.33552 14.1712 8.33552C14.4101 8.33552 14.6037 8.52914 14.6037 8.76795V18.9842C14.6037 19.223 14.4101 19.4166 14.1712 19.4166C13.9324 19.4166 13.7388 19.223 13.7388 18.9842V8.76795ZM10.5496 8.76795C10.5496 8.52914 10.7432 8.33552 10.9821 8.33552C11.2209 8.33552 11.4145 8.52914 11.4145 8.76795V18.9842C11.4145 19.223 11.2209 19.4166 10.9821 19.4166C10.7432 19.4166 10.5496 19.223 10.5496 18.9842V8.76795ZM7.36043 8.76795C7.36043 8.52914 7.55405 8.33552 7.79286 8.33552C8.03167 8.33552 8.2253 8.52914 8.2253 8.76795V18.9842C8.2253 19.223 8.03167 19.4166 7.79286 19.4166C7.55405 19.4166 7.36043 19.223 7.36043 18.9842V8.76795Z",
  fill: "#84CDBD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.67483 5.83794H18.291C18.8881 5.83794 19.372 5.35399 19.372 4.75686C19.372 4.15973 18.8881 3.67578 18.291 3.67578H3.67483C3.0777 3.67578 2.59375 4.15973 2.59375 4.75686C2.59375 5.35399 3.0777 5.83794 3.67483 5.83794Z",
  fill: "#84CDBD"
});

var SvgCalendardelete = function SvgCalendardelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendardelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendardelete.ed49b80d.svg";
export { ForwardRef as ReactComponent };